import React, {useEffect, useState} from 'react'
import {Typography} from '@mui/material'
import {useDispatch} from 'react-redux'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import {MoonLoader} from 'react-spinners'
import dayjs from 'dayjs'
import {useHistory} from 'react-router-dom'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import {hasPermission} from '../../../../../_helper/hasPermission'
import {permissions} from '../../../../../_constants/permissions'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {Button} from '@mui/material'
import axios from 'axios'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import { BEHAVIOUR_ASSESSMENT_LISTING_COLUMNS ,BEHAVIOUR_ASSESSMENT_SORTING_COLUMNS,
  BEHAVIOUR_ASSESSMENT_COLUMNS_DATA_MAPPING} from '../../../Notes/Behaviour_Notes/BEHAVIOUR_TABLE_CONSTANTS'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import NoteEntryModal from '../../../../reusable-components/Modals/NoteEntryModal'

const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedBehaviourAssesmentList = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [deletedID, setDeletedID] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(false)
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const history = useHistory()
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const [fullData, setFullData] = useState<any[]>([])

  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      try {
        setIsFetchingData(true)
        const response = await axios.get('/behavior-assessment/getAll', {
          params: {
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortDir: sortDir,
            searchTerm: queryData.searchTerm,
             isDeleted: true,
          },
        })
        const data = response.data.data
        setFullData(data)
        setFilteredData(data)
        setIsFetchingData(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        toast.error('Failed to fetch data')
        setIsFetchingData(false)
      }
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
    deletedID
  ])
  const handleUpdate = (row: any) => {
    history.push(`/deleted-notes/behaviour-notes/${row._id}`)
  }

  const handleView = (row: any) => {
    history.push(`/deleted-notes/behaviour-notes/entry/list/${row._id}/${row.clientId}/${row?.noteType}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        <div>
          <TableTitle title='Behavior Assessment' />
          <TableWrapper
            searchField={
              <TableSearchBar
                label='Search'
                variant='outlined'
                size='small'
                value={searchTerm}
                setQueryData={setQueryData}
                setSearchTerm={setSearchTerm}
                margin='normal'
              />
            }
            dynamicTable={
              <>
              <span className='ml-2 text-primary d-flex align-items-center gap-2'>For view Behavior notes please click on <VisibilityOutlinedIcon /> icon in the table</span>
              <DynamicTable
                columns={BEHAVIOUR_ASSESSMENT_LISTING_COLUMNS}
                canUpdate={hasPermission(userPermissions, permissions.notes_behavior_note_update)}
                onUpdate={handleUpdate}
                canView={hasPermission(userPermissions, permissions.notes_behavior_note_entry_view)}
                onView={handleView}
                data={filteredData}
                sortingColumns={BEHAVIOUR_ASSESSMENT_SORTING_COLUMNS}
                clickableRow={false}
                queryData={queryData}
                setQueryData={setQueryData}
                tableLoader={isFetchingData}
                columnDataMapping={BEHAVIOUR_ASSESSMENT_COLUMNS_DATA_MAPPING}
              />
              </>
            }
          />
        </div>
      </div>
    </div>
  )
}

export default DeletedBehaviourAssesmentList
